/**
 * Class description
 *
 * Created: 2019-08-02
 * @author jonas
 */


import {TimelineLite, Timeline} from "gsap";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { GameRoundPresentation } from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {WinterHoardReelSymbol} from "../symbols/WinterHoardReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";


export class WinterHoardFreeSpinOverlayPresentation implements GameRoundPresentation {

    private _data:WinterHoardParsedGameData;
    private _multipliers:number[];
    private _tl:TimelineLite;
    private _shouldPlay:boolean;

    private _energyCollectedBefore:number;
    private _energyCollectedAfter:number;
    private _energyCollectPositions:boolean [][] = [];
    private _overlayM1:boolean [][] = [];

    private _fsLeft = 0;
    private _addFreespins:number = 0;

    private _symbolMultipliers:{
        M1:number,
        M2:number,
        M3:number,
        M4:number,
        M5:number
    }; // make a hash/map typing
    private _level:number = 0;

    constructor() {
    }


    prepare(data:ParsedServerData):void {

        /*
         TODO:
          All M1:s landing will give energy to the indicators
         */

        this._data = <WinterHoardParsedGameData>data;
        this._addFreespins = this._data.addFreespins | 0;
        this._overlayM1 = this._data.overlayM1;
        this._shouldPlay = data.mode == GameMode.FREESPIN && data.nextMode == GameMode.NORMAL;
        this._energyCollectedBefore = this._data.energyCollectedBefore;
        this._energyCollectedAfter = this._data.energyCollectedAfter;
        this._energyCollectPositions = this._data.energyCollectPositions;
        this._symbolMultipliers = {
            M1: this._data.symbolMultipliers.M1 || 1,
            M2: this._data.symbolMultipliers.M2 || 1,
            M3: this._data.symbolMultipliers.M3 || 1,
            M4: this._data.symbolMultipliers.M4 || 1,
            M5: this._data.symbolMultipliers.M5 || 1
        };


        this._fsLeft = data.freespinsLeft; // + data.addedNumberOfFreespinsThisSpin;
        if(data.addedNumberOfFreespinsThisSpin > 0) {
            //debugger;
        }

        if(this._energyCollectedBefore < (this._energyCollectedAfter) && this._energyCollectedAfter <= 25) {

            for(let i = this._energyCollectedBefore; i < this._energyCollectedAfter; i++) {
                if(i > -1 && i < 6) {
                    // 1, 2, 3, 4, 5
                    this._level = 1;
                }
                else if(i > 5 && i < 11) {
                    this._level = 2;
                }
                else if(i > 10 && i < 16) {
                    this._level = 3;
                }
                else if(i > 15 && i <= 20) {
                    this._level = 4;
                }
            }
        }

        else {
            this._level = 0;
        }

        //console.log("EC BEFORE: " + this._energyCollectedBefore);
        //console.log("EC AFTER: " + this._energyCollectedAfter);
        //console.log(this._data.evaluatedReels);
        //console.log(this._energyCollectPositions);

        /*console.log("SYMBOL MULTIPLIERS");
        console.log(this._symbolMultipliers);

        console.log("------------------- FREESPIN DATA -------------------- FREESPINS PLAYED: " + this._data.freespinsPlayed);
        console.log(data);*/

        /*
        energyCollectedBefore: 18
        energyCollectedAfter: 18
        symbolsToM1
         */

        //This if, is here because the values are reset to 0 on the last spin, when this presentations is actually started. By doing this we save the latest data.
        if(data.mode == GameMode.FREESPIN && data.nextMode == GameMode.FREESPIN) {
            this._multipliers = [];
            for(let i:number = 0; i < 5; i++) {
                const multiplier:number = Math.max(1, this._data.scattersCollected[i] - 2);
                this._multipliers.push(multiplier);
            }
            Logger.logDev("Multipliers", this._multipliers);
        }

    }



    getAnimation():TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let timelineSetup: Timeline [] = [];
        const isRestore: boolean = (<any>this._data).isRestoreState;
        // Update symbol counter view data

        if (this._data.mode === "FREESPIN_PICK") {
            if (this._data.nextMode === "FREESPIN_TRANSFORM") {
                timelineSetup = WinterHoardGameModuleConfig.freeSpinCounterView.updateData(this._energyCollectedBefore, this._energyCollectedAfter, this._energyCollectPositions, isRestore, this._fsLeft);
            } else if (this._data.nextMode === "FREESPIN_MULTIPLIER") {
                timelineSetup = WinterHoardGameModuleConfig.freeSpinMultiplierView.updateData(this._energyCollectedBefore, this._energyCollectedAfter, this._energyCollectPositions, this._symbolMultipliers, this._data.nextMode, isRestore, this._fsLeft);
            } else if (this._data.nextMode === "FREESPIN_COMBINED") {
                timelineSetup = WinterHoardGameModuleConfig.freeSpinMultiplierView.updateData(this._energyCollectedBefore, this._energyCollectedAfter, this._energyCollectPositions, this._symbolMultipliers, this._data.nextMode, isRestore, this._fsLeft);
            }
        } else {
            if (this._data.mode === "FREESPIN_TRANSFORM") {
                timelineSetup = WinterHoardGameModuleConfig.freeSpinCounterView.updateData(this._energyCollectedBefore, this._energyCollectedAfter, this._energyCollectPositions, isRestore, this._fsLeft);
            } else if (this._data.mode === "FREESPIN_MULTIPLIER") {
                if ((<any>this._data).isRestoreState) {
                    WinterHoardGameModuleConfig.symbolDataStopped.symbolMultipliers = this._symbolMultipliers;
                }

                timelineSetup = WinterHoardGameModuleConfig.freeSpinMultiplierView.updateData(this._energyCollectedBefore, this._energyCollectedAfter, this._energyCollectPositions, this._symbolMultipliers, this._data.mode, isRestore, this._fsLeft);
            } else if (this._data.mode === "FREESPIN_COMBINED") {
                if (isRestore) {
                    WinterHoardGameModuleConfig.symbolDataStopped.symbolMultipliers = this._symbolMultipliers;
                }

                timelineSetup = WinterHoardGameModuleConfig.freeSpinMultiplierView.updateData(this._energyCollectedBefore, this._energyCollectedAfter, this._energyCollectPositions, this._symbolMultipliers, this._data.mode, isRestore, this._fsLeft);
            }
        }

        const updateCount: number = this._energyCollectedAfter - this._energyCollectedBefore;
        let nrOfCollectPositions: number = 0;

        this._energyCollectPositions.forEach((arr) => {
            arr.forEach((bool) => {
                if (bool) {
                    nrOfCollectPositions++;
                }
            });
        });

        tl.add(WinterHoardGameModuleConfig.overlayView.getTransformNormal(this._overlayM1));

        if (this._energyCollectedBefore < 20) {
            // This is adding overlay M1:s on other M-symbols
            if (nrOfCollectPositions > 0) {
                tl.add(WinterHoardGameModuleConfig.overlayView.getEnergyAnimation(this._energyCollectPositions, this._overlayM1));
            }

            if (this._shouldPlay) { // TODO: Statement is off

                // oboslete?
                //tl.add(WinterHoardGameModuleConfig.overlayView.updateAll(this._data, this._multipliers));
            }

            if (nrOfCollectPositions > 0) {
                // Tmp delay
                tl.add(() => {
                }, "+=0.5");

                // TODO: Tmp, hide energy
                //  pass symbol counter view timeline list to hideEnergy
                //tl.add(timelineSetup.play());
                // TODO: THIS ALSO CALLS ENERGY TRANSMISSION
                tl.add(WinterHoardGameModuleConfig.overlayView.hideEnergyAnimation(this._energyCollectPositions, timelineSetup, this._level,
                    {before: this._energyCollectedBefore, after: this._energyCollectedAfter})); // Add level

                tl.add(() => {

                    //if(this._data.nextMode !== "NORMAL") {
                    [0, 1, 2, 3, 4].forEach((rid) => {
                        [0, 1, 2, 3].forEach((sid) => {
                            const symbol: WinterHoardReelSymbol | null = <WinterHoardReelSymbol>Reels.getSymbol(rid, sid);
                            if (symbol && symbol.symName === "M1") {
                                symbol.playNormalSpine();
                            }
                        });
                    });
                    //}
                }, "+=1.5");
            }
        } else if ((<any>this._data).isRestoreState) {
            tl.add(WinterHoardGameModuleConfig.overlayView.updateAll(this._data, this._multipliers));
        }


        if (this._addFreespins > 0) {
            tl.add(() => {
            }, "+=1.5");
        }





        this._tl = tl;
        return this._tl;
    }

    abort(isActive:boolean):TimelineLite | null {
        this._tl.add(() => {
            [0, 1, 2, 3, 4].forEach((rid) => {
                [0, 1, 2 , 3].forEach((sid) => {
                    const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol> Reels.getSymbol(rid, sid);
                    if(symbol && symbol.symName === "M1") {
                        symbol.playNormalSpine();
                    }
                });
            });
        });
        return this._tl;
    }

}